function Config() {

    let Core = {
        DateFormatNoTime: 'Y.m.d',
        DateFormatNoYear: 'm-d H:i',
    };

    return Core;

}

export default new Config();